import numberHumanizer from '@/helpers/numberHumanizer';
import { useState, type MouseEventHandler } from 'react';
import { Spinner } from 'react-bootstrap';
import { AiOutlineZoomIn } from 'react-icons/ai';
// برای نمایش تعداد در جدول
type CountRendererProps = {
  data?: number | string | null;
  onClick?: MouseEventHandler<SVGElement>;
};

const CountRenderer = ({ data, onClick }: CountRendererProps) => {
  const [opened, setOpened] = useState(false);
  return (
    <>
      {data && (
        <>
          <div className="d-flex align-items-center gap-1">
            <span
              onClick={() => {
                setOpened(true);
                setTimeout(() => {
                  setOpened(false);
                }, 1500);
              }}
            >
              {!opened ? (
                <AiOutlineZoomIn
                  onClick={onClick}
                  className="cursor-pointer fs-0"
                />
              ) : (
                <Spinner
                  animation="border"
                  style={{
                    width: '18px',
                    marginBottom: '-3px',
                    paddingLeft: '3px',
                    height: '18px'
                  }}
                />
              )}
            </span>
            <span>{numberHumanizer(data) || data}</span>
          </div>
        </>
      )}
    </>
  );
};

export default CountRenderer;
